import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const anyOtherHeartDisorder: AnswerPathTreeNode = {
  path: 'anyOtherHeartDisorder',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAnyOtherHeartDisorderDetails }],
};
